// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners_wrapper__x22ml","partner":"Partners_partner__bSMTC","skeleton":"Partners_skeleton__UItQy"};